import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Field, reduxForm, change } from 'redux-form';
import { Title } from '@app/src/common/Title';
import { TabProfile } from '@app/src/views/StepPayment/formPayment';
import {
  TermsAndConditions,
  LinkTermsAndConditions,
  FormWrapper,
  PaymentSummary,
  SummaryDescription,
  TextDescription
} from './styled';
import { renderCheckbox } from '@app/src/common/Checkbox';
import { Disclaimer } from '@app/src/common/Disclaimer';
import * as validate from '@app/src/utils/validations';
import { ModalErrorFeature } from '@app/src/common/modalError';
import {
  fetchPricePackage,
  createDniData,
  updateDniData,
  createRucData,
  updateRucData,
  sendDataPayment
} from '@app/src/views/StepPayment/formPayment';
import { isClientEnv } from '@app/src/utils/validations';
import { FormActions } from '@app/src/views/StepPayment/formPayment/components/FormActions';
import { ModalProcessPayment } from '@app/src/views/StepPayment/formPayment/components/ModalProcessPayment';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { setCategoryPackage, setIdPackage } from '@app/src/views/Package/listPackage';
import { fetchValidate } from '@app/src/common/session';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();
const STATE_PAYMENT = {
  SUCESS: 'approved',
  PENDING: 'pending',
  DENIED: 'denied',
  FAILURED: 'failed'
};
const PAYMENT_CONFIRM_URL = '/confirmacion-de-pago-paquete';
const PAYMENT_PENDING_URL = '/pendiente-de-pago-paquete';
const PACKAGE_URL = '/compra-tu-paquete';

interface Props {
  handleSubmit?: Function;
  reset?: Function;
  touch?: Function;
  untouch?: Function;
  clearSubmitErrors?: Function;
}

const Form: React.FC<Props> = ({ handleSubmit, untouch }) => {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const priceTotal = useSelector(state => state.pricePackage.data.total);
  const price = useSelector(state => state.pricePackage.data);
  const isLoading = useSelector(state => state.pricePackage.isFetching);
  const error = useSelector(state => state.pricePackage.error);
  const currentDocumentType = useSelector(state => state.form.stepPayment.values.documentType);
  const currentTerms = useSelector(state => state.form.stepPayment.values.termsAndConditions);
  const currentPhone = useSelector(state => state.form.stepPayment.values.phone);
  const currentBusinessPhone = useSelector(state => state.form.stepPayment.values.businessPhone);
  const dniData = useSelector(state => state.dni.data);
  const rucData = useSelector(state => state.ruc.data);
  const isLoadingDniCreate = useSelector(state => state.dni.isFetchingCreate);
  const isLoadingDniUpdate = useSelector(state => state.dni.isFetchingUpdate);
  const isLoadingRucCreate = useSelector(state => state.ruc.isFetchingCreate);
  const isLoadingRucUpdate = useSelector(state => state.ruc.isFetchingUpdate);
  const isLoadingPayment = useSelector(state => state.payment.isFetching);
  const [isShowModal, setIsShowModal] = useState(false);
  const statusPayment = useSelector(state => state.processConfirm.data.status);
  const currentCategory = useSelector(state => state.package.categorySelected);
  const theme = CATEGORIES[CATEGORY[currentCategory]];
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const [isPayment, setIsPayment] = useState(false);
  const [buildData, setBuildData] = useState(null);
  const processConfirmData = useSelector(state => state.processConfirm.data);

  useEffect(() => {
    if (processConfirmData && processConfirmData.status === STATE_PAYMENT.DENIED) {
      setIsShowModal(false);
    }
  }, [processConfirmData]);

  useEffect(() => {
    if (userStorage && userStorage.jwt) {
      const { packageId, categoryId } = userStorage;
      dispatch(setCategoryPackage(categoryId));
      dispatch(setIdPackage(packageId));
      dispatch(fetchPricePackage(categoryId, userStorage && userStorage.uniqueId));

      let head = document.getElementsByTagName('head')[0];
      head.insertBefore(createCulqiScript(), head.firstChild);
      return () => {
        head.removeChild(head.childNodes[0]);
      }
    } else {
      history.push('/inicia-tu-sesion', { from: 'purchase-package' });
    }
  }, []);

  useEffect(() => {
    if (userStorage && userStorage.jwt && validate && validate.email && isPayment) {
      setIsPayment(false);
      sendForm(buildData);
    }
  }, [validate, isPayment, buildData]);

  const sendForm = useCallback((data) => {
    let profileData = dniData;
    const paymentData = {
      printDetail: id,
      category: currentCategory,
      package: true,
      user: userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
    };
    if (currentDocumentType === 'RUC') {
      profileData = rucData;
    }
    if (Object.keys(profileData).length === 0) {
      if (currentDocumentType === 'DNI') {
        dispatch(createDniData(data, paymentData, priceTotal, setIsShowModal));
        return;
      }
      if (currentDocumentType === 'RUC') {
        dispatch(createRucData(data, paymentData, priceTotal, setIsShowModal));
        return;
      }
    } else {
      if (currentDocumentType === 'DNI' && isChangeInputsTicketContact(profileData)) {
        dispatch(updateDniData(data, profileData.documentNumber, paymentData, priceTotal, setIsShowModal));
        return;
      }
      if (currentDocumentType === 'RUC' && isChangeInputsBillContact(profileData)) {
        dispatch(updateRucData(data, profileData.documentNumber, paymentData, priceTotal, setIsShowModal));
        return;
      }
      dispatch(sendDataPayment({
        ...paymentData,
        customer: profileData.id
      }, priceTotal, setIsShowModal));
    }
  }, [currentDocumentType, priceTotal, dniData, rucData, currentPhone, currentBusinessPhone]);


  useEffect(() => {
    if (isClient) {
      (window as any).paymentProcess = true;
    }
  }, []);

  useEffect(() => {
    if (isClient && statusPayment) {
      sessionStorage.setItem('print', JSON.stringify({ general: { category: currentCategory } }));
      const updateUser = { ...userStorage };
      delete updateUser.uniqueId;
      localStorage.setItem('user', JSON.stringify(updateUser));
      if (statusPayment === STATE_PAYMENT.SUCESS) {
        history.push(`${PAYMENT_CONFIRM_URL}${userStorage && userStorage.urlGenerated}`);
      }
      if (statusPayment === STATE_PAYMENT.PENDING) {
        history.push(`${PAYMENT_PENDING_URL}${userStorage && userStorage.urlGenerated}`);
      }
    }
  }, [statusPayment, currentCategory]);

  const createCulqiScript = () => {
    if (isClient) {
      let script = document.createElement('script');
      script.setAttribute('src', 'https://js.culqi.com/checkout-js');
      script.setAttribute('id', 'srcCulqi');
      return script;
    }
  };

  const handleClickSubmit = (data): void => {
    pushDatalayerPackage(theme.name, data);
    setIsPayment(true);
    setBuildData(data);
    if (userStorage && userStorage.jwt) {
      dispatch(fetchValidate());
    } else {
      history.push('/inicia-tu-sesion', { from: 'purchase-package' });
    }
  };

  const getProfileType = (value: string): void => {
    dispatch(change('stepPayment', 'documentType', value));
  };

  const handleChangeCheckbox = (value: boolean): void => {
    dispatch(change('stepPayment', 'termsAndConditions', value));
  };

  const isChangeInputsTicketContact = (profileData) => {
    return currentPhone !== profileData.phone;
  };

  const isChangeInputsBillContact = (profileData): boolean => {
    return (currentBusinessPhone !== profileData.phone);
  };

  const pushDatalayerPackage = (categoryName: string, data) => {
    const document = data.documentType;
    let facture = 'Boleta';
    if (document === 'RUC') {
      facture = 'Factura';
    }
    const updateUser = {
      ...userStorage,
      facture
    };
    isClient && localStorage.setItem('user', JSON.stringify(updateUser));
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EvPasosdecompra',
        'category': `P2_${categoryName}`,
        'action': `${userStorage && userStorage.titleLayer}_${facture}`,
        'label': userStorage && userStorage.user || userStorage.data && userStorage.data.id,
        'value': 1
      })
    }
  };

  const setTextButtonNext = useCallback((): string => (isLoading || error) ? 'cargando...' : `Pagar S/ ${priceTotal}`, [isLoading, error]);

  const setDisabledButtonNext = (): boolean => isLoading || isLoadingDniCreate || isLoadingDniUpdate || isLoadingPayment || isLoadingRucCreate || isLoadingRucUpdate;

  const handleClickBack = () => {
    history.push(`${PACKAGE_URL}-${theme && theme.nameAlias}`);
  };

  return (
    <React.Fragment>
      <ModalErrorFeature />
      <FormWrapper onSubmit={handleSubmit(handleClickSubmit)}>
        <Title>Tipo de comprobante</Title>
        <TabProfile
          handleChangeAction={untouch}
          getProfileType={getProfileType}
          color={COLORS.BLUE_LINK} />
        <Field
          name="termsAndConditions"
          component={renderCheckbox}
          checked={currentTerms}
          handleChange={handleChangeCheckbox}
          validate={[validate.required]}
          colorActive={COLORS.BLUE_LINK}
        >
          <TermsAndConditions>
            Acepto los <LinkTermsAndConditions target="_blank" color={COLORS.BLUE_LINK} href="/terminos-y-condiciones">Términos y Condiciones</LinkTermsAndConditions> / <LinkTermsAndConditions target="_blank" color={COLORS.BLUE_LINK} href="/politicas-de-privacidad">Política de privacidad</LinkTermsAndConditions> de Clasificados.pe
          </TermsAndConditions>
        </Field>
        <PaymentSummary color={'#f0f0f0'}>
          {
            isLoading ? 'Cargando...' :
              <React.Fragment>
                {
                  price && price.subTotal ?
                    <SummaryDescription>
                      <TextDescription>Sub Total</TextDescription>
                      <TextDescription>{price && `S/ ${price.subTotal}`}</TextDescription>
                    </SummaryDescription> : null
                }
                {
                  price && price.discount ?
                    <SummaryDescription>
                      <TextDescription>Descuento ({price && price.discount}%)</TextDescription>
                      <TextDescription>{price && `S/ ${price.totalDiscount}`}</TextDescription>
                    </SummaryDescription> : null
                }
                <SummaryDescription>
                  <TextDescription>IGV ({price && price.igv}%)</TextDescription>
                  <TextDescription>{price && `S/ ${price.igvTotal}`}</TextDescription>
                </SummaryDescription>
                <SummaryDescription>
                  <TextDescription isBold>Total a pagar (Inc. IGV.)</TextDescription>
                  <TextDescription isBold>{price && `S/ ${price.total}`}</TextDescription>
                </SummaryDescription>
              </React.Fragment>
          }
        </PaymentSummary>
        <Disclaimer />
        <FormActions
          disabledButtonNext={setDisabledButtonNext()}
          textButtonNext={setTextButtonNext()}
          handleClickBack={handleClickBack}
          textButtonBack="Paquetes"
        />
        <ModalProcessPayment isDisplay={isShowModal} />
      </FormWrapper>
    </React.Fragment>
  )
};

const FormHoc = reduxForm({
  form: 'stepPayment',
  initialValues: {
    dni: '',
    name: '',
    fatherLastName: '',
    motherLastName: '',
    phone: '',
    ruc: '',
    rznSocial: '',
    businessName: '',
    businessFatherLastName: '',
    businessMotherLastName: '',
    businessAddress: '',
    businessPhone: '',
    businessEmail: '',
    districtId: '',
    departmentId: '',
    documentType: 'DNI'
  }
})(Form);

export { FormHoc as FormPaymentPackage };
